export const MESSAGE_RESULT = {
  OK: '',
  NOT_INPUT: (item) => `${item}を入力してください。`,
  NOT_SELECT: (item) => `${item}を選択してください。`,
  NOT_SPACE: 'スペースだけで入力しないでください。',
  OVER_DIGITS: (item, num) => `${item}の最大文字数は${num}文字です。`,
  OUTOF_DIGITS: (item, num) => `${item}は${num}文字で入力してください。`,
  NOT_NAME: (item) => `正しい${item}を入力してください。`,
  NOT_KANA_NAME: (item) => `${item}は全角カタカナを入力してください。`,
  NOT_HANKAKU_KANA: (item) => `${item}は半角カタカナを入力してください。`,
  NOT_HANKAKU: (item) => `${item}は半角文字を入力してください。`,
  NOT_ZENKAKU: (item) => `${item}は全角文字を入力してください。`,
  NOT_NUMBER: (item) => `${item}は数字のみ入力してください。`,
  NOT_PHONE_NUMBER: '電話番号は10桁以上11桁以下で入力してください。',
  NOT_POSTALCODE: '会社住所(郵便番号)は7桁で入力してください。',
  NOT_ADDRESSCODE: '住所コードは11桁で入力してください。',
  INCORECT_FORMAT: (item) => `${item}の形式が正しくありません。`,
  NOT_RANGER: (min, max) => `${min}から${max}までの数字を入力してください`,
  NOT_ALPHANUMERIC: (item) => `${item}は半角英数字を入力してください。`,
  NOT_NUMERIC: (item) => `${item}は半角数字を入力してください。`,
  NOT_CHECK: 'チェックをつけてください',
  NOT_AGREE_CHECK: (item) => `${item}をチェックしてください`,
  NOT_SPECIAL_CHARACTER: (item) => `${item}に「&<>"'」を入力しないでください。`,
  NOT_INCLUDES: (item) => `${item}に表示されている値を選択してください。`,
  NOT_SELLER_CODE: 'ドコモ代理店、NTTCom代理店の販売担当者コードを入力してください。',
  OVER_FILE_SIZE: (item, str) => `${item}の添付ファイルサイズは${str}までにしてください。`,
  NOT_FILE_TYPE: (item) => `${item}の添付ファイルはjpeg、jpg、png、pdfを添付してください。`,
};

export const NETWORK_ERROR_MESSAGE = 'ネットワークに接続されていません。接続を確認してください。';
